import { getErrorPayload } from '@application/common/helpers/api-helper';
export const asHourRegistrationError = (error) => error && typeof error === 'object' && typeof error.status === 'number'
    ? error
    : getErrorPayload(error);
export const hourRegistrationErrorMessage = (error, action) => {
    const apiError = asHourRegistrationError(error);
    const reference = apiError.correlationId ? ` Reference: ${apiError.correlationId}.` : '';
    const code = apiError.code ? ` (${apiError.code})` : '';
    if (apiError.status === 401)
        return `Your session expired. Sign in again to ${action}.${reference}`;
    if (apiError.status === 403)
        return `You are not allowed to ${action}.${reference}`;
    const detail = apiError.status < 500
        ? apiError.validationErrors?.join(' ') || apiError.error
        : undefined;
    const fallback = apiError.status === 409
        ? 'The timesheet has changed or its saved routing is no longer valid.'
        : `The portal could not ${action}. Try again.`;
    return `${detail || fallback}${code}${reference}`;
};
